import api from '../api/feedback';

export default {
    getHome400: payload => api.getHome400(payload),
    getFeedbackContact: payload => api.getFeedbackContact(payload),
    submitFeedback: payload => {
        let subData = {
            type: '2',
            from: '2'
        };
        _.extend(subData, payload);

        return api.submitFeedback(subData);
    },

    submitError: payload => {
        let subData = {
            type: '1',
            from: '2'
        };
        _.extend(subData, payload);

        return api.submitFeedback(subData);
    }
}



// WEBPACK FOOTER //
// ./src/model/service/feedback.js